export const formatFileSize = (size: number) => {
  const kb = 1024;
  const mb = Math.pow(kb, 2);
  const gb = Math.pow(kb, 3);
  if (size >= gb) return `${(size / gb).toFixed(2)}GB`;
  if (size >= mb) return `${(size / mb).toFixed(2)}MB`;
  if (size >= kb) return `${(size / kb).toFixed(2)}KB`;
  return `${size}B`;
};

export const isXML = (filename?: string) =>
  filename?.toLowerCase().endsWith(".xml") ?? false;
